//合同路由
export default [{
  path: 'contractsList',
  name: 'contractsList',
  component: function component() {
    return import('@/views/contractManage/contractList/index');
  }
}, {
  path: 'contractsAdd',
  name: 'contractsAdd',
  component: function component() {
    return import('@/views/contractManage/contractList/add');
  }
}, {
  path: 'contractsDetails',
  name: 'contractsDetails',
  component: function component() {
    return import('@/views/contractManage/contractList/details');
  }
}, {
  path: 'cancelDetails',
  name: 'cancelDetails',
  component: function component() {
    return import('@/views/contractManage/contractList/cancelDetails');
  }
}, {
  path: 'editCancelDetails',
  name: 'editCancelDetails',
  component: function component() {
    return import('@/views/contractManage/contractList/editCancelDetails');
  }
}];